module.exports = __webpack_public_path__ + "img/empty-groups.454407c6.svg";